import React from "react";
import {Table, Space, Popconfirm, Tooltip} from "antd";
import { useSelector } from "react-redux";
import {
  DeleteOutlined,
  EditOutlined,
  UpCircleOutlined,
} from "@ant-design/icons";
import classes from "./class-list.module.scss";
import { selectClasses } from "../../../../reducers/class/selectors";
import { TOOLTIP_BACKGROUND_COLOR } from "../../../../constants/common";

const ClassList = ({ onEdit, onDelete, handleSwitch, isLoading }) => {
  const data = useSelector(selectClasses);

  const onSwitch = (item, index) => {
    const upperItem = data[index - 1];
    handleSwitch(item.class_id, upperItem.class_id);
  };

  const columns = [
    {
      title: "Name",
      key: "class_name",
      width: "40%",
      render: (_, record, index) => (
        <Space size="middle" className={classes.NameWrap}>
          <div className={classes.Text}>{record.class_name}</div>
          {index !== 0 && (
            <div className={classes.SwapIconWrap}>
              <Tooltip
                placement="top"
                title={"Move up"}
                color={TOOLTIP_BACKGROUND_COLOR}
              >
                <UpCircleOutlined
                  className={classes.SwapIcon}
                  onClick={() => onSwitch(record, index)}
                />
              </Tooltip>
            </div>
          )}
        </Space>
      ),
    },
    {
      title: "Description",
      key: "class_description",
      render: (_, record) => (
        <Space size="middle">{record.class_description}</Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: "150px",
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            placement="bottom"
            title="Are you sure to delete this class?"
            onConfirm={() => onDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined className={classes.DeleteIcon} />
          </Popconfirm>

          <EditOutlined
            className={classes.EditIconIcon}
            onClick={() => onEdit(record)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        loading={isLoading}
        bordered
        columns={columns}
        dataSource={data}
        className={classes.ListItems}
        scroll={{ x: 800, y: "calc(100vh - 250px)" }}
        pagination={false}
      />
    </div>
  );
};

export default ClassList;
